var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.emails ? _c('div', [_vm._l(_vm.emails, function (email, index) {
    return [_c('a', {
      key: email,
      attrs: {
        "href": 'mailto:' + email
      }
    }, [_vm._v(_vm._s(email))]), index + 1 < _vm.emails.length ? _c('span', {
      key: email
    }, [_vm._v(", ")]) : _vm._e()];
  })], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }